import { render } from "./OnboardingPopUp.vue?vue&type=template&id=2436116e&ts=true"
import script from "./OnboardingPopUp.vue?vue&type=script&lang=ts"
export * from "./OnboardingPopUp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__